import { DefaultContext, EventObject, MachineConfig, StateSchema } from 'xstate/es';

import { FormPropertyReportStatechartEvent } from 'common/module/property-report/statechart.event';
import { FormPropertyReportStatechartActionEnum } from 'common/module/property-report/statechart/action.enum';
import { FormPropertyReportStatechartStateEnum } from 'common/module/property-report/statechart/state.enum';

export const FormPropertyReportStatechart: MachineConfig<DefaultContext, StateSchema, EventObject> = {
  initial: FormPropertyReportStatechartStateEnum.idle,
  states: {
    [FormPropertyReportStatechartStateEnum.idle]: {
      on: {
        [FormPropertyReportStatechartEvent.wantToSendReport]: FormPropertyReportStatechartStateEnum.validating,
      },
    },
    [FormPropertyReportStatechartStateEnum.validating]: {
      entry: [FormPropertyReportStatechartActionEnum.validateFields],
      on: {
        [FormPropertyReportStatechartEvent.validationPassed]:
          FormPropertyReportStatechartStateEnum.checkingIfWasAlreadySent,
        [FormPropertyReportStatechartEvent.validationFailed]: FormPropertyReportStatechartStateEnum.idle,
      },
    },
    [FormPropertyReportStatechartStateEnum.executingCaptcha]: {
      entry: [
        FormPropertyReportStatechartActionEnum.setSubmittingStatus,
        FormPropertyReportStatechartActionEnum.executeCaptcha,
      ],
      on: {
        [FormPropertyReportStatechartEvent.captchaValueChanged]:
          FormPropertyReportStatechartStateEnum.checkingIfWasAlreadySent,
      },
    },
    [FormPropertyReportStatechartStateEnum.checkingIfWasAlreadySent]: {
      entry: [
        FormPropertyReportStatechartActionEnum.setSubmittingStatus,
        FormPropertyReportStatechartActionEnum.checkIfWasAlreadySent,
      ],
      on: {
        [FormPropertyReportStatechartEvent.wasAlreadySent]: FormPropertyReportStatechartStateEnum.uploadingAttachment,
        [FormPropertyReportStatechartEvent.wasNotSent]: FormPropertyReportStatechartStateEnum.updateUser,
      },
    },
    [FormPropertyReportStatechartStateEnum.updateUser]: {
      entry: [FormPropertyReportStatechartActionEnum.doUserUpdate],
      on: {
        [FormPropertyReportStatechartEvent.userUpdateSuccess]: FormPropertyReportStatechartStateEnum.submitting,
        [FormPropertyReportStatechartEvent.userUpdateFailed]: {
          target: FormPropertyReportStatechartStateEnum.idle,
          actions: [FormPropertyReportStatechartActionEnum.showErrors],
        },
      },
    },
    [FormPropertyReportStatechartStateEnum.checkingIfHasAttachment]: {
      entry: [FormPropertyReportStatechartActionEnum.checkIfHasAttachment],
      on: {
        [FormPropertyReportStatechartEvent.hasAttachment]: FormPropertyReportStatechartStateEnum.uploadingAttachment,
        [FormPropertyReportStatechartEvent.hasNoAttachment]: FormPropertyReportStatechartStateEnum.sent,
      },
    },
    [FormPropertyReportStatechartStateEnum.submitting]: {
      onEntry: [FormPropertyReportStatechartActionEnum.sendCreateReportRequest],
      on: {
        [FormPropertyReportStatechartEvent.reportCreated]:
          FormPropertyReportStatechartStateEnum.checkingIfHasAttachment,
        [FormPropertyReportStatechartEvent.reportCreateFailed]: {
          target: FormPropertyReportStatechartStateEnum.idle,
          actions: [FormPropertyReportStatechartActionEnum.showErrors],
        },
      },
    },
    [FormPropertyReportStatechartStateEnum.uploadingAttachment]: {
      onEntry: [FormPropertyReportStatechartActionEnum.uploadAttachment],
      on: {
        [FormPropertyReportStatechartEvent.uploadSuccessful]: FormPropertyReportStatechartStateEnum.sent,
        [FormPropertyReportStatechartEvent.uploadFailed]: {
          target: FormPropertyReportStatechartStateEnum.idle,
          actions: [FormPropertyReportStatechartActionEnum.showErrors],
        },
      },
    },
    [FormPropertyReportStatechartStateEnum.sent]: {
      onEntry: [FormPropertyReportStatechartActionEnum.setSubmittedStatus],
    },
  },
};
